import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { getVisaTypeCode, getSubTaskDetails, loadSubTaskDetails } from 'visa-store';
import { getSubTaskList } from 'src/app/modules/superTask/task-state/reducers/task.reducer';
import { TaskStep, SubTaskDetails, PrimaryData } from 'app-models';
import { combineLatest, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { VisaExtendedState } from '../../utility/interfaces/visa-extended-state';
import { ActivatedRoute, Router } from '@angular/router';
import { DEPENDENT_VISAS } from 'app-models';
import * as Task from 'src/app/modules/superTask/task-state/actions/task.actions';
import * as RolesRouteMap from 'src/app/data/constants/roles';
import { PetitionerService } from 'src/app/services/petitioner.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { I140SubheaderService } from './i140-subheader.service';
import { ToastrService } from 'ngx-toastr';
import { loadPetitionSubTaskDetails } from 'src/app/modules/petition-builder/store/actions/sub-task-details.actions';


@Component({
  selector: 'app-visa-subheader',
  templateUrl: './i140-subheader.component.html',
  styleUrls: ['./i140-subheader.component.scss']
})
export class I140SubheaderComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  inputSubheader;

  @Input()
  visaTypeName;

  @Input()
  toggleSubTaskDetailsPanelBtn: boolean;

  @Input()
  decisionETADateRange;

  @Input()
  primaryData: PrimaryData;

  @Output()
  subTaskPanelToggleEvent: EventEmitter<boolean> = new EventEmitter();

  @Output()
  stepClick: EventEmitter<TaskStep> = new EventEmitter();
  @Input() taskTypeCode: string;

  @Input() disabledControl: boolean = false;

  subTaskToggleBtn: boolean;
  task: SubTaskDetails;
  stepDetails: TaskStep;
  isUpdateDecisionBtnDisabled: boolean;
  filingDate: string;
  // visaTypeName: string;
  userTypeRole: string;
  userType: string;
  observableSubscription$ = new Subject();
  taskId: number = null;
  isDecisionAvaiable: boolean;
  showUpdateEmploymentBtn = true;
  isDependentVisa = false;
  showCreateI485SubTask: boolean;
  i485Present = true;
  showCreateDS260SubTask: boolean;
  ds260Present: any;
  showCreateDS160SubTask: boolean;
  ds160Present: any;
  dialogRef: DynamicDialogRef;
  isSimplify: boolean;
  showSettingOptions: boolean;

  constructor(
    private store: Store<VisaExtendedState>,
    private router: Router,
    private route: ActivatedRoute,
    private petitionerService: PetitionerService,
    private dialogService: DialogService,
    private subheaderService: I140SubheaderService
  ) {
    this.subTaskToggleBtn = false;
    this.isUpdateDecisionBtnDisabled = true;
    this.userTypeRole = sessionStorage.getItem('userTypeRole');
    this.store.pipe(select(getSubTaskDetails))
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: SubTaskDetails) => {
        if (data.id) {
          this.task = data;
          if (this.task && this.task.taskTypeDetails) {
            this.showUpdateEmploymentBtn = (this.task.taskTypeDetails.immCategoryCode && this.task.taskTypeDetails?.immCategoryCode === 'ASYLUM' || (this.task.taskTypeDetails.visaType && ['K1', 'K3'].includes(this.task.taskTypeDetails.visaType))) ? false : true;
          }
          this.taskId = data.id;
        }
      });
    this.isDecisionAvaiable = false;

  }

  ngOnInit() {
    if (sessionStorage.getItem("isSimplify") == 'CWF') {
      this.isSimplify = true;
    } else {
      this.isSimplify = false;
    }
    this.userType = sessionStorage.getItem('userTypeRole');
    combineLatest([
      this.store.pipe(select(getSubTaskList)),
      this.store.pipe(select(getVisaTypeCode))
    ])
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: any[]) => {
        this.i485Present =
          response[0] && response[0].length > 0 ?
            response[0].some(task => task.taskTypeCode && task.taskTypeCode === 'I485') :
            false;
        this.ds260Present =
          response[0] && response[0].length > 0 ?
            response[0].some(task => task.taskTypeCode && task.taskTypeCode === 'DS260') :
            false;
        this.ds160Present =
          response[0] && response[0].length > 0 ?
            response[0].some(task => task.taskTypeCode && task.taskTypeCode === 'DS160') :
            false;
        if (response[1]) {
          this.filingDate = (response[0].find(x => x.taskTypeCode === 'PETITION'))?.filingDate;
        }
      });
    // Get Sub task Details
    this.store.pipe(select(getSubTaskDetails))
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: SubTaskDetails) => {
        if (data.id) {
          this.task = data;
          this.taskId = data.id;
          if(!this.visaTypeName){
          this.visaTypeName = data.taskTypeDetails && data.taskTypeDetails.visaName ?
            data.taskTypeDetails.visaName :
            (data.taskTypeDetails && data.taskTypeDetails.immCategory) ?
              data.taskTypeDetails.immCategory : null;}
          let submitPetitionStepDetails;
          if (this.task.subTaskTypeCode && this.task.subTaskTypeCode === 'PWDEFILE') {
            submitPetitionStepDetails = this.task.taskStepDetails[this.task.taskStepDetails.length - 1];
          } else if (this.task.isOutsideImagility) {
            submitPetitionStepDetails = this.task.taskStepDetails.find(x => x.stepActionList[0].layoutCode === 'UPLOAD_RCPTS');
          } else {
            submitPetitionStepDetails = this.task.taskStepDetails.find(x => x.stepActionList?.[0].layoutCode === 'GET_RECEIPT');
          }

          if (submitPetitionStepDetails && submitPetitionStepDetails.stepStatusDetails
            && submitPetitionStepDetails.stepStatusDetails.stepStatusCode === 'COMPLETE') {
            this.isUpdateDecisionBtnDisabled = false;
          } else {
            this.isUpdateDecisionBtnDisabled = true;
          }
          if (this.task.taskTypeDetails && this.task.taskTypeDetails.visaType) {
            this.isDependentVisa = DEPENDENT_VISAS.includes(this.task.taskTypeDetails.visaType);
          }
        }
      });
  }

  ngOnChanges(e: SimpleChanges) {
    if (e.toggleSubTaskDetailsPanelBtn && e.toggleSubTaskDetailsPanelBtn.currentValue === false) {
      this.subTaskToggleBtn = e.toggleSubTaskDetailsPanelBtn.currentValue;
    }
    if (this.primaryData && this.taskTypeCode) {
      this.showSettingOptions = this.primaryData.caseType === 'I130' || ["APPLTOREPLRESICARD","APPLN400","TRVLDOCI131","ASYLAFFIRM","EB765BASE","APPLFORNATUR400"].includes(this.primaryData.immigrationClassification)  ? true : false;
      switch (this.taskTypeCode) {
        case 'I130':
          this.showCreateI485SubTask = true;
          // this.showCreateDS260SubTask = true;
          break;
        case 'PETITION':
          if (this.primaryData.visatype && this.primaryData.visatype === 'ASYLUM') {
            this.showCreateI485SubTask = true;
          //  this.showCreateDS260SubTask = true;  //IMGLT-26307 fix
          }
          if (this.task.superTaskTypeCode === 'NONIMMPET') {
            this.showCreateDS160SubTask = true;
          }

          break;
        default:
          this.showCreateI485SubTask = false;
          this.showCreateDS260SubTask = false;
          this.showCreateDS160SubTask = false;
          break;
      }
    }
  }

  handleUpdateDeterminaion() {
    this.stepClick.emit({ stepActionList: [{ layoutCode: 'UPDATE_DETERMINATION' }] });
  }

  handleUpdateDecision() {
    this.stepClick.emit({ stepActionList: [{ layoutCode: 'UPDATE_DECISION' }] });
  }

  handleSendNotification() {
    this.stepClick.emit({ stepActionList: [{ layoutCode: 'SEND_NOTIFICATION' }] });
  }

  toggleUpdateEmploymentView() {
    // this.onStepClick.emit({ stepName: 'Update Employment' });
    this.subTaskToggleBtn = false;
    this.subTaskPanelToggleEvent.emit(this.subTaskToggleBtn);
    this.router.navigate(['../update-employment'], { relativeTo: this.route });
  }

  toggleSubTask() {
    if (this.disabledControl) return;
    this.subTaskToggleBtn = !this.subTaskToggleBtn;
    if (!this.subTaskToggleBtn) {
      this.petitionerService.getSuperTask(sessionStorage.getItem('taskID')).subscribe();
    }
    this.subTaskPanelToggleEvent.emit(this.subTaskToggleBtn);
  }

  createI485Task() {
    this.store.dispatch(new Task.SetI485Petition(this.task));
    sessionStorage.removeItem('requestDataDocument');
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/new`]);
  }

  createDS260Task() {
    this.store.dispatch(new Task.SetDS260Petition(this.task));
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/new`]);
  }

  createDS160Task() {
    this.store.dispatch(new Task.SetDS160Petition(this.task));
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/new`]);
  }

  createTask(type) {
    this.store.dispatch(new Task.SetSubPetition({
      subTaskDetails: this.task,
      type
    }));
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/new`]);
  }

  handleSetting() {
    const ref = this.dialogService.open(EfilingSettingComponent, {
      header: 'Setting',
      width: '70%',
      data: { primaryData: this.primaryData }
    });

  }

  ngOnDestroy(): void {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

}

@Component({
  selector: 'efiling-dialog',
  templateUrl: 'efiling-setting-dialog.html'
})
export class EfilingSettingComponent implements OnInit, OnDestroy {
  efilingSettingForm: FormGroup;
  primaryData: any;
  observableSubscription$ = new Subject();
  constructor(
    private fb: FormBuilder,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private subheaderService: I140SubheaderService,
    public toastr: ToastrService,
    private store: Store<VisaExtendedState>,
    ) {
    //this.resetForm();
  }
  ngOnInit() {
    this.primaryData = this.config.data.primaryData;
    this.efilingSettingForm = this.fb.group({
      filingType: ['standard']
      //familyId: [null, Validators.required],
    });
    this.getSettingValues();
  }

  getSettingValues() {
    this.subheaderService
      .getSetting(
        this.primaryData.caseType,
        this.primaryData.subTaskId
      )
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: any) => {
        if(response?.data?.filingType){
          this.efilingSettingForm.patchValue({
            filingType:response.data.filingType
          })
        }
      });

  }
  handleSaveSetting() {
    const payload = {
      ... this.efilingSettingForm.value
    }
    this.subheaderService
      .saveSetting(
        this.primaryData.caseType,
        this.primaryData.subTaskId, payload
      )
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: any) => {
        if (response) {
          this.toastr.success(response.message, 'Success');
          this.store.dispatch(loadSubTaskDetails({
            taskId: this.primaryData.subTaskId,
            visaTypeCode: this.primaryData.caseType
          }));
         // window.location.reload()
         
        }
      });
  }
  handleCancel() {
    this.getSettingValues();
   
  }
  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

}
